import { ArrowOutward } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import classNames from "classnames";
import { makeStyles } from "components/providers/makeStyles";
import { trackClick, TrackingCategory } from "utils/tracking";
import { SponsorConfig } from "../../../graphql/generated/types";
import { gql } from "@apollo/client";

export const SponsoredContentFragment = gql`
    fragment SponsoredContent on Event {
        id
        sponsoredContent {
          id
          sponsor {
            id
            config {
              text
              image
              url
            }
          }
        }
    }
`;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        width: "fit-content",
        flexWrap: "wrap",
        alignItems: "center",
        gap: theme.spacing(0.5),
        wordBreak: "break-word",

        "a&:hover > *": {
            color: theme.palette.text.primary,
        },
    },
    image: {
        maxWidth: "110px",
        maxHeight: "32px",
        objectFit: "contain",
        objectPosition: "left",
    },
    arrow: {
        color: theme.palette.text.light,
    },
}));

// TODO: replace this with Sponsor type when backend is done
export type SponsorTagProps = {
    sponsoredContent: SponsorConfig;
    clickTracking?: {
        label: string;
        category: TrackingCategory;
    };
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    clickable?: boolean;
    className?: string;
};

const noop = () => {};
export const SponsorTag: React.FC<SponsorTagProps> = ({
    sponsoredContent,
    clickTracking,
    onClick = noop,
    clickable = true,
    className
}) => {
    const classes = useStyles();
    const { text, image, url } = sponsoredContent;
    const hasTracking = url && clickable && !!clickTracking;
    const tracking = hasTracking
        ? trackClick(onClick)(clickTracking.label, clickTracking.category)
        : noop;
    
    return (
        // @ts-expect-error
        <Box component={url && clickable ? "a" : "div"}
             href={url}
             target={url ? "_blank" : undefined}
             rel={url ? "noopener noreferrer" : undefined}
             onClick={(event: React.MouseEvent<HTMLElement>) => tracking(event)}
             className={classNames(classes.root, className)}
             data-group
        >
            <Typography variant="body2" color="text.light">
                {text}
            </Typography>
            <img src={image} className={classes.image} alt="sponsor" />
            {url && clickable && <ArrowOutward fontSize="small" className={classes.arrow} />}
        </Box>
    );
};
